import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { Section } from 'styles';
import { SubTitle, TimeTable } from 'components';

import outdoorWeatherStationService from 'services/outdoor/outdoor-weather-station-service';
import commonSensorService from 'services/common-sensor-service';

const timeList = [
  { name: '전체', val: 'all' },
  { name: '오전', val: 'am' },
  { name: '오후', val: 'pm' },
];

export function Outdoor(props) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [sensor, setSensor] = useState({});
  const [sensorUnit, setSensorUnit] = useState(null);
  const [sensorData, setSensorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chartInputData, setChartInputData] = useState(null);
  const [tableInputData, setTableInputData] = useState(null);
  const [chartOverrideOptions, setChartOverrideOptions] = useState(null);
  const [hourlyList, setHourlyList] = useState([]);

  const [filters, setFilters] = useState({
    date: moment(new Date()).format('YYYY.MM.DD'),
    searchEndDate: moment(new Date()).format('YYYY.MM.DD'),
    type: 'all',
    timeType: 'all',
    apiCallIndex: 0
  });

  const onChange = (name, val) => {
    setFilters({ ...filters, [name]: val });
  };

  const updateChartInputData = (data, chartDisplayType, sensorType) => {
    const newChartInputData = commonSensorService.processChartInputData(data, chartDisplayType,
      filters.date === filters.searchEndDate ? 'HH' : 'YYYY-MM-DD HH:mm:ss');

    let legendName = '평균';
    let color = '#E05353';

    if (sensorType) {
      if (sensorType.toUpperCase().startsWith('TEMP_')) {
        legendName = '외부온도';
        color = '#85E48C';
      } else if (sensorType.toUpperCase().startsWith('RH_')) {
        legendName = '외부습도';
        color = '#35C9D2';
      } else if (sensorType.toUpperCase().startsWith('WIND_')) {
        legendName = '외부풍향';
      } else if (sensorType.toUpperCase().startsWith('WINDSPEED_')) {
        legendName = '외부풍속';
      } else if (sensorType.toUpperCase().startsWith('SOLAR_')) {
        legendName = '외부일사';
      }
    }

    setChartInputData({
      labels: newChartInputData.labels,
      data1: {
        name: legendName,
        color,
        data: newChartInputData.data1.data
      }
    });
  }

  const updateTableInputData = (data) => {
    const processedData = commonSensorService.processTableInputData(data);

    setTableInputData(processedData);
  }

  const updateChartOverrideOptions = (sensorType) => {
    const overrideOptions = commonSensorService.getChartOverrideOptions(sensorType);

    setChartOverrideOptions(overrideOptions);
  }

  useEffect(() => {
    const fetchData = async () => {
      const startTime = moment(filters.date).format('YYYYMMDD000000');
      const endTime = moment(filters.searchEndDate).format('YYYYMMDD235959');

      // // 날짜 차이를 계산
      // const monthsDiff = moment(filters.searchEndDate).diff(moment(filters.date), 'months');
      
      // // 6개월 이상이면 alert 창 표시
      // if (monthsDiff > 6) {
      //   alert('6개월 이상은 조회 할 수 없습니다. \n값을 다시 설정해 주세요');
      //   setLoading(false);
      //   return; // 데이터 요청을 중단
      // }

      let data = [];
      let tempHourlyList = Array.from({ length: 24 }, (_, i) => i);
      try {
        data = await outdoorWeatherStationService.getWeatherStationDetail(searchParams.get('type'), startTime, endTime);

        const daysDiff = moment(filters.searchEndDate).diff(moment(filters.date), 'days');
                        
        let hourlyModulo = 1;

        if (daysDiff >= 90) {
          hourlyModulo = 12;
          tempHourlyList = [0, 12];
        } else if (daysDiff >= 30) {
          hourlyModulo = 6;
          tempHourlyList = [0, 6, 12, 18];
        } else if (daysDiff >= 14) {
          hourlyModulo = 2;
          tempHourlyList = Array.from({ length: 12 }, (_, i) => i * 2);
        }

        data = data.filter((d) => moment(d.timestamp).hours() % hourlyModulo === 0);
      } catch (e) {
        console.error(e);
      }

      if (data && data.length > 0) {
        setSensor(data[0]);
        setSensorUnit(commonSensorService.getSensorUnit(data[0].sensor_type))
        setSensorData(data);
        setHourlyList(tempHourlyList);
      } else {
        setSensor({});
        setSensorUnit(null);
        setSensorData([]);
        setHourlyList([]);
      }

      setLoading(false)
    }

    setLoading(true);
    fetchData();
  }, [searchParams, filters.apiCallIndex]);

  useEffect(() => {
    updateChartOverrideOptions(sensor.sensor_type);
    updateChartInputData(sensorData, filters.type, sensor.sensor_type)
    updateTableInputData(sensorData);
  }, [sensorData, filters.type])

  return (
    <Section>
      <SubTitle title="외부기상대" sub="Outdoor" desc={sensor.sensor_name} />
      <TimeTable filters={filters} onChange={onChange} timeList={timeList} chartInputData={chartInputData} tableInputData={tableInputData}
          loading={loading} unit={sensorUnit} chartOverrideOptions={chartOverrideOptions}
          onClickSearchDate={() => {
            onChange('apiCallIndex', filters.apiCallIndex + 1)
          }}
          dateStartEndSearch
          hourlyList={hourlyList} />
    </Section>
  )
}
